import SmallDetails from "components/SmallDetails/SmallDetails";
import React from "react";
import { BankAccountPreview } from "../BankAccount/BankAccountPreviewPanel";

interface Props {
  bankAccount: server.dto.BankAccountSmall
}

export const BankAccountDetails = ({ bankAccount }: Props) => {
  return <BankAccountPreview
    bankAccountId={bankAccount.bankAccountId}
    trigger={<div className="preview-panel-list-item hoverable flex-column">
      <SmallDetails
        label={bankAccount.title}
        subLabel={bankAccount.beneficiaryName}
      />
    </div>}
  />
}